module.exports = __webpack_public_path__ + "static/img/3610_phase_function_Paper_PointsHejduk_Prediction.eb19712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3610_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZK3G
// module chunks = 0